import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestInfoFormFonts from './TestInfoFormFont'
import TestInfoFormStyle from './TestInfoFormStyle'
import type { TestInfoFormBrandType, TestInfoBrandForms } from './testInfoTypes'

const FORM_MAP: TestInfoBrandForms = {
  [BrandFormEnum.STYLE]: TestInfoFormStyle,
  base: TestInfoFormFonts,
}

const TestInfoFormBrand: TestInfoFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestInfoFormBrand) as typeof TestInfoFormBrand
